"use strict";import{tag as i}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const ShowMenuIcon=({width:t=24,height:e=24,hidden:r=!1,title:h="Show Menu"}={})=>i`<svg
    xmlns="http://www.w3.org/2000/svg"
    height=${e}
    viewBox="0 0 36 36"
    width=${t}
    aria-hidden=${r?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label=${h}
  >
    <rect height="4" rx="1" ry="1" width="28" x="4" y="16" />
    <rect height="4" rx="1" ry="1" width="28" x="4" y="6" />
    <rect height="4" rx="1" ry="1" width="28" x="4" y="26" />
  </svg>`;
//# sourceMappingURL=ShowMenu.js.map
